document.addEventListener(
"DOMContentLoaded",
function(){

const questions=document.querySelectorAll(
".faq-question"
);


questions.forEach(function(question){

question.addEventListener(
"click",
function(){

const item=this.parentElement;

item.classList.toggle("active");

});

});


});